import { useEffect, useRef } from "react";
import { Camera, ImagePlus, X } from "lucide-react";

/** Choix de photos avant envoi : appareil photo ou galerie, avec aperçu.
 * value = [{ id, file, url }] */
export function PhotoPicker({ value, onChange, max = 12 }) {
  const latest = useRef(value);
  latest.current = value;
  // Libère les aperçus à la fermeture.
  useEffect(() => () => latest.current.forEach((p) => URL.revokeObjectURL(p.url)), []);

  const ajouter = (e) => {
    const files = Array.from(e.target.files || []).filter((f) => f.type.startsWith("image/") || /\.(heic|heif|jpe?g|png|webp)$/i.test(f.name));
    e.target.value = "";
    const place = Math.max(0, max - value.length);
    onChange([...value, ...files.slice(0, place).map((file) => ({ id: `${file.name}-${file.size}-${Math.random()}`, file, url: URL.createObjectURL(file) }))]);
  };
  const retirer = (id) => {
    const p = value.find((x) => x.id === id);
    if (p) URL.revokeObjectURL(p.url);
    onChange(value.filter((x) => x.id !== id));
  };
  const btn = "inline-flex items-center gap-2 h-9 px-3 rounded-md border border-input text-sm cursor-pointer hover:bg-accent";

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        <label className="inline-flex">
          <input type="file" accept="image/*" capture="environment" className="hidden" onChange={ajouter} data-testid="photo-camera" />
          <span className={btn}><Camera size={15} /> Prendre une photo</span>
        </label>
        <label className="inline-flex">
          <input type="file" accept="image/*" multiple className="hidden" onChange={ajouter} data-testid="photo-galerie" />
          <span className={btn}><ImagePlus size={15} /> Galerie</span>
        </label>
        {value.length > 0 && <span className="self-center text-xs text-muted-foreground">{value.length} photo(s)</span>}
      </div>
      {value.length > 0 && (
        <div className="grid grid-cols-4 sm:grid-cols-5 gap-2" data-testid="photo-apercus">
          {value.map((p) => (
            <div key={p.id} className="relative aspect-square rounded-md overflow-hidden border border-border bg-muted">
              <img src={p.url} alt="" className="w-full h-full object-cover" />
              <button type="button" onClick={() => retirer(p.id)} className="absolute top-1 right-1 p-0.5 rounded-full bg-black/60 text-white" aria-label="Retirer">
                <X size={13} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
